/**
 * Centralized auth redirect — prevents redirect storms from multiple systems.
 * Only ONE redirect can happen at a time. Subsequent calls are ignored.
 */
let redirectInProgress = false;

export function authRedirect(path, reason) {
  if (redirectInProgress) return;
  if (window.location.pathname === path || window.location.pathname.startsWith(path.split('?')[0])) return;
  redirectInProgress = true;
  window.location.href = reason ? `${path}?reason=${reason}` : path;
}

export function isRedirecting() {
  return redirectInProgress;
}

export function resetRedirectGuard() {
  redirectInProgress = false;
}
